<div>
  <button
    matSuffix
    mat-icon-button
    color="primary"
    aria-label="swap scenario"
    i18n-aria-label="@@swapScenarioLabel"
    (click)="onSwapScenario()"
    i18n-matTooltip="@@swapScenarioTooltip"
    matTooltip="Switch to another scenario"
    [matTooltipShowDelay]="1000"
    [disabled]="disabled"
  >
    <mat-icon class="swap-button">swap_horiz</mat-icon>
  </button>
</div>
